/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YardInventoryRowResponse } from './YardInventoryRowResponse';
import {
    YardInventoryRowResponseFromJSON,
    YardInventoryRowResponseFromJSONTyped,
    YardInventoryRowResponseToJSON,
    YardInventoryRowResponseToJSONTyped,
} from './YardInventoryRowResponse';

/**
 * 
 * @export
 * @interface YardInventoryResponse
 */
export interface YardInventoryResponse {
    /**
     * 
     * @type {Array<YardInventoryRowResponse>}
     * @memberof YardInventoryResponse
     */
    rows?: Array<YardInventoryRowResponse>;
    /**
     * 
     * @type {number}
     * @memberof YardInventoryResponse
     */
    count?: number;
}

/**
 * Check if a given object implements the YardInventoryResponse interface.
 */
export function instanceOfYardInventoryResponse(value: object): value is YardInventoryResponse {
    return true;
}

export function YardInventoryResponseFromJSON(json: any): YardInventoryResponse {
    return YardInventoryResponseFromJSONTyped(json, false);
}

export function YardInventoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): YardInventoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(YardInventoryRowResponseFromJSON)),
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function YardInventoryResponseToJSON(json: any): YardInventoryResponse {
    return YardInventoryResponseToJSONTyped(json, false);
}

export function YardInventoryResponseToJSONTyped(value?: YardInventoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(YardInventoryRowResponseToJSON)),
        'count': value['count'],
    };
}

